import React, { useEffect, useState } from 'react';
import { MorphSelect } from '../../utilities/MorphSelect.tsx';
import { ReptoolModal } from '../../utilities/ReptoolModal.tsx';
import { MorphGeneInputs } from '../../utilities/MorphGeneInputs.tsx';
import { Gene } from '../../../types/Gene.ts';
import { Morph } from '../../../types/Morph.ts';
import { CollectionReptile } from '../types/CollectionTypes.ts';
import { BasicFetch } from '../../../utils/BasicFetch.ts';
import { useRepToolContext } from '../../../RepToolContext.tsx';

export const ChangeMorphModal = ({
  collectionReptile,
  setReptile,
  closeModal,
  morphs,
  genes,
  isSpecies
}: {
  collectionReptile: CollectionReptile,
  setReptile: (reptile: CollectionReptile) => void,
  closeModal: () => void,
  morphs: Morph[],
  genes: Gene[],
  isSpecies: boolean
}) => {
  const [geneEdit, setGeneEdit] = useState(false);
  const [morphEdit, setMorphEdit] = useState(isSpecies);
  const [morphName, setMorphName] = useState(collectionReptile.morph_name || '');
  const [selectedMorph, setSelectedMorph] = useState(null);
  const { appendControls } = useRepToolContext();
  const [currentGenes, setCurrentGenes] = useState<Gene[]>(collectionReptile.genes.length > 0 ? collectionReptile.genes.map(gene => {
    return {
      id: gene.gene_id,
      gene_name: gene.gene_name,
      gene_type: gene.gene_type,
      expression: gene.expression,
      reptile: collectionReptile.reptile,
    }
  }) : []);

  const saveChanges = (morphName: string, currentGenes: Gene[], morph: Morph | null) => {
    BasicFetch({
      url: `${(window as any).serverLocation}/collection_reptile/${collectionReptile.id}/edit_morph`,
      method: 'POST',
      data: {
        morph_name: morphName,
        genes: currentGenes,
        morph_name_id: morph?.morph_name_id
      },
      onSuccess: (data) => {
        setReptile(data.reptile);
        closeModal();
      }, onFail: () => {
        window.alert("There was a problem saving your changes. Please try again later.");
      }
    })
  }

  useEffect(() => {
    appendControls(null);
  }, [])

  return (
    <ReptoolModal id="change-morph-dialog" title={`Change ${isSpecies ? "Species" : "Genetics"}`} closeModal={closeModal} body={(
      <>
        {!morphEdit && !geneEdit && <>
          <div id="changeMorph" className="button expand"
            onClick={() => setMorphEdit(true)}>
            Change By Morph
          </div>
          {!isSpecies && <div id="changeGenes" className="button mt-3 expand"
            onClick={() => setGeneEdit(true)}>
            Change By Genes
          </div>}
        </>}
        {geneEdit &&
          <MorphGeneInputs
            genes={genes}
            morphs={morphs}
            presetGenes={currentGenes}
            setMorphName={setMorphName}
            setCurrentGenes={setCurrentGenes}
          />
        }
        {morphEdit && <>
          <h6></h6>
          <MorphSelect
            morphs={morphs}
            id={'change-morph-type'}
            morphTyped={(morph) => { setSelectedMorph(morph); setMorphName(morph.name) }}
            morph={selectedMorph}
            isSpecies={isSpecies}
          />
        </>
        }

        <hr />
        <div className="mt-3">
          <h5>{isSpecies ? 'Species' : 'Morph'} Name: </h5>
          <span>{morphName}</span>
        </div>

        {(morphEdit || geneEdit) &&
          <>
            <div className={`button mt-5 expand animated ${morphName ? 'fadeIn' : 'd-none'}`}
              onClick={() => {
                const morph = morphEdit ? morphs.find(morph => morph.name === morphName) : null;
                saveChanges(morphName, geneEdit ? currentGenes : [], morph || null);
              }}>
              Save Changes
            </div>
            <div className="button mt-3 expand bg-black"
              onClick={() => { setMorphEdit(false); setGeneEdit(false) }}>
              Cancel
            </div>
          </>
        }
      </>
    )} />
  )
}